module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-32x32-b5ca358f46b5c0082554486c2ddc70b4.png";